

import store from "@/store";
import { Album, AudioFile } from "@/store/mp3player/types";
import { defineComponent, ref, onMounted, onUnmounted, reactive } from "vue";
import LibraryFilterView from "@/components/mp3player/LibraryFilterView.vue";
import LibraryAlbum from "@/components/mp3player/LibraryAlbum.vue";
import AudioPlayer from "@/components/mp3player/AudioPlayer.vue";
import LibraryFilterView2 from "@/components/mp3player2/LibraryFilterView2.vue";
import LibraryAlbum2 from "@/components/mp3player2/LibraryAlbum2.vue";
import AudioPlayer2 from "@/components/mp3player2/AudioPlayer2.vue";
import { LibraryFilter, LibraryFilterValue } from "@/components/mp3player/mp3player-types";
import { GetLibraryPost } from "@/store/mp3player/api-types";
import { Service } from "@/store/user/types";

enum State {
  Show = 0,
  Hidden = 1,
  GenreHidden = 2
}

export default defineComponent({
  components: { LibraryFilterView, LibraryAlbum, AudioPlayer, LibraryFilterView2, LibraryAlbum2, AudioPlayer2 },
  name: 'Mp3Player',
  data() {
    return {
      mobileViewLoading: false,
      currentSlide: 1,
      startX: 0,
      endX: 0,
      isMobile: false,
      title: 'MP3',
      currentAudioFile: null,
      loading: false,
      userServices: [],
      updateProcess: false,
      cursorLoading: false,
      loadAlbums: [] as Album[],
      albums: [] as Album[],
      albumId: null as any,
      audioList: reactive([] as AudioFile[]),
      file: null as any,
      selectedInList: null as any,
      timer: 0,
      info: '',
      yearFilter: {
        name: 'Год',
        values: []
      } as LibraryFilter,
      artistsFilter: {
        name: 'Артисты',
        values: []
      } as LibraryFilter,
      genresFilter: {
        name: 'Жанры',
        values: []
      } as LibraryFilter,
      ratingsFilter: {
        name: 'Рейтинги',
        values: []
      } as LibraryFilter,
      window: {
        width: 0,
        height: 0,
        cover: 450
      },
      styleObjectLibrary: reactive({
        width: '900px',
        height: '800px'
      }),
      styleObjectFilters: reactive({
        width: '900px',
        height: '100px'
      })
    }
  },
  created() {
      this.window = store.getters['window/windowSize']
      this.userServices = store.getters['user/userServices']
  },
  watch: {
    window: {
      handler(newVal) {
        this.isMobile = false
        this.styleObjectLibrary.width = '900px'
        if (newVal.width < 1450) {
          if (newVal.width > 1150) {
              this.styleObjectFilters.width = (newVal.width - 560) + 'px'
              this.styleObjectLibrary.width = (newVal.width - 560) + 'px'
          } else if (newVal.width > 600) {
              this.styleObjectFilters.width = '600px'
              this.styleObjectLibrary.width = '600px'
          }  else if (newVal.width > 500) {
              this.styleObjectFilters.width = '600px'
              this.styleObjectLibrary.width = '600px'
          }  else {
              this.isMobile = true
          }
        }
        this.styleObjectLibrary.height = (newVal.height - 170) + 'px'
      },
      deep: true
    },
    userServices: {
      handler(newVal) {
        console.log('newVal' + newVal)
        newVal.forEach((element: Service) => {
          if (element.service == '80a6d350-fc81-4116-a8e1-18e02d789980') {
            let tempGenres: number[] = []
            let tempAlbumTypes: number[] = []
            element.genres.forEach(element => {
                tempGenres.push(element)
            })
            element.album_types.forEach(element => {
                tempAlbumTypes.push(element)
            })
            const getLibraryPost: GetLibraryPost = {
              album_types: tempAlbumTypes,
              genres: tempGenres
            }
            this.loadLibrary(getLibraryPost)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    handleTouchStart(e: TouchEvent) {
      this.startX = e.touches[0].clientX
      console.log(this.startX)
    },

    handleTouchEnd(e: TouchEvent) {
      this.endX = e.changedTouches[0].clientX
      const diff = this.startX - this.endX
      if (Math.abs(diff) > 50) { // Минимальная дистанция для свайпа
        if (diff > 0) {
          this.swipe(true)
        } else if (diff < 0) {
          this.swipe(false)
        }
      }
    },

    handleKeyDown(e: KeyboardEvent) {
      console.log(e.key)
      if (e.key === 'ArrowLeft') {
        this.swipe(false)
      } else if (e.key === 'ArrowRight') {
        this.swipe(true)
      }
    },

    swipe(direction: boolean) {
      if (direction === true) {
        if (this.currentSlide < 2) {
          this.currentSlide++
        } else {
          this.currentSlide = 0
        }
      } else {
        if (this.currentSlide > 0) {
          this.currentSlide--
        } else {
          this.currentSlide = 2
        }
      }
    },

    addAll() {
      console.log('addAll count albums: ' + this.albums.length)
      this.albums.forEach(album => {
        album.audioFiles.forEach(audioFile => {
          const findedRatingFilter = this.ratingsFilter.values.find((value: LibraryFilterValue) => value.value == audioFile.rating)
          if (findedRatingFilter) {
            if (findedRatingFilter.selected === true) {
              if (!this.audioList.find((el: AudioFile) => el.id === audioFile.id)) {
                this.audioList.push(Object.assign(audioFile))
              }
            }
          }
          audioFile.selected = false
        });
      });
    },
    gift() {
      console.log(this.albums.length)
      this.audioList = []
      if (this.albums.length > 1) {
        const rand = Math.floor((Math.random() * this.albums.length) + 1);
        let randChange = rand
        console.log(rand)
        let flag = true
        while (flag) {
          if (randChange >= this.albums.length) {
            randChange = 0
          }
          this.albums[randChange].audioFiles.forEach(audioFile => {
            if (audioFile.count == null) {
              flag = false
            }
          })
          if (flag) {
            ++randChange
            if (randChange === rand) {
              flag = false
            }
          } else {
            this.albums[randChange].audioFiles.forEach(audioFile => {
              if (!this.audioList.find((el: AudioFile) => el.id === audioFile.id)) {
                this.audioList.push(Object.assign(audioFile))
              }
            })
          }
        }

        if (this.audioList.length === 0) {
          let albumId = null
          let leastTime = new Date()
          for (let index = 0; index < this.albums.length; index++) {
            const element = this.albums[index]
            element.audioFiles.forEach(audioFile => {
              if (audioFile.lastPlayed !== null) {
                const lastPlayed = new Date(audioFile.lastPlayed)
                if (lastPlayed.getTime() < leastTime.getTime()) {
                  albumId = index
                  leastTime = lastPlayed
                }
              }
            })
          }

          if (albumId !== null) {
             this.albums[albumId].audioFiles.forEach(audioFile => {
              if (!this.audioList.find((el: AudioFile) => el.id === audioFile.id)) {
                this.audioList.push(Object.assign(audioFile))
              }
            })
          }
        }
      }
    },
    addToPlaylist() {
      this.albums.forEach(album => {
        album.audioFiles.forEach(audioFile => {
          if (audioFile.selected) {
            if (!this.audioList.find((el: AudioFile) => el.id === audioFile.id)) {
              this.audioList.push(Object.assign(audioFile))
            }
            audioFile.selected = false
          }
        });
      });
    },
    clearPlaylist() {
      this.audioList = []
    },
    changeTrack(value: number) {
      this.albums.forEach((album: Album) => {
        if (album.audioFiles.find((audioFile: AudioFile) => audioFile.id === value)) {
          this.albumId = album
        }
      })
    },
    selectValueFilter(value: LibraryFilterValue) {
      this.cursorLoading = true
      setTimeout(() => {this.changeFilter(value, false)},1);
    },
    addValueFilter(value: LibraryFilterValue) {
      this.cursorLoading = true
      setTimeout(() => {this.changeFilter(value, false)},1);
    },
    changeFilter(value: LibraryFilterValue, type: boolean) {
      if (value.value === 0) {
        switch (value.type) {
          case 'year':
            this.yearFilter.values.forEach(yearElement => {
              yearElement.selected = false
            });
            break;

          case 'artist':
            this.artistsFilter.values.forEach(artistElement => {
              artistElement.selected = false
            });
            break;

          case 'genre':
            this.genresFilter.values.forEach(genreElement => {
              genreElement.selected = false
            });
            break;

          case 'rating':
            this.ratingsFilter.values.forEach(ratingElement => {
              ratingElement.selected = false
            });
            break;

          default:
            break;
        }
      } else {
        switch (value.type) {
          case 'rating':
            this.ratingsFilter.values.forEach((el: LibraryFilterValue) => {
              if (el.value == value.value) {
                el.selected = !el.selected
              } else {
                if (type) {
                  el.selected = false
                }
              }
            })
            break;
          case 'year':
            this.yearFilter.values.forEach((el: LibraryFilterValue) => {
              if (el.value == value.value) {
                el.selected = !el.selected
              } else {
                if (type) {
                  el.selected = false
                }
              }
            })
            break;

          case 'artist':
            this.artistsFilter.values.forEach((el: LibraryFilterValue) => {
              if (el.value == value.value) {
                el.selected = !el.selected
              } else {
                if (type) {
                  el.selected = false
                }
              }
            })
            break;

          case 'genre':
            this.genresFilter.values.forEach((el: LibraryFilterValue) => {
              if (el.value == value.value) {
                el.selected = !el.selected
              } else {
                if (type) {
                  el.selected = false
                }
              }
            })
            break;

          default:
            break;
        }
      }
      this.updateAlbums(this.loadAlbums)
    },
    filterHasSelected(filter: LibraryFilter) {
      if (filter.values.find((el: LibraryFilterValue) => el.selected == true)) {
        return true
      }
      return false
    },
    async loadLibrary(getLibraryPost: GetLibraryPost) {
      if (!store.getters['mp3player/lastUpdate']) {
        this.loading = true
        this.info = 'Загружаем....'
        store.dispatch('mp3player/loadLibrary', getLibraryPost)
          .then(() => {
            return store.getters['mp3player/albums']
          })
          .then(async (albums: Album[]) => {
            this.loadAlbums = albums
            await this.createFilters(this.loadAlbums)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.loadAlbums = store.getters['mp3player/albums']
        this.createFilters(this.loadAlbums)
      }
    },
    async createFilters(albums: Album[]) {
      let yearFilter: LibraryFilter = {
        name: 'Год',
        values: []
      }

      let artistsFilter: LibraryFilter = {
        name: 'Артисты',
        values: []
      }

      let genresFilter: LibraryFilter = {
        name: 'Жанры',
        values: []
      }

      let ratingsFilter: LibraryFilter = {
        name: 'Рейтинги',
        values: []
      }

      albums.forEach(async (album: Album) => {
        album.audioFiles.sort((a, b) => (a.trackNo < b.trackNo ? -1 : 1))

        const findedYearFilter = this.yearFilter.values.find((value: LibraryFilterValue) => value.value == album.year)

        if (!findedYearFilter) {
          if (!yearFilter.values.find((value: LibraryFilterValue) => value.value == album.year)) {
            const libraryFilterValue: LibraryFilterValue = {
              type: 'year',
              value: album.year,
              selected: false
            }
            yearFilter.values.push(libraryFilterValue)
          }
        } else {
          if (!yearFilter.values.find((value: LibraryFilterValue) => value.value == album.year)) {
            const libraryFilterValue: LibraryFilterValue = {
              type: 'year',
              value: album.year,
              selected: findedYearFilter.selected
            }
            yearFilter.values.push(libraryFilterValue)
          }
        }

        const findedArtistsFilter = this.artistsFilter.values.find((value: LibraryFilterValue) => value.value == album.artist)

        if (!findedArtistsFilter) {
          if (!artistsFilter.values.find((value: LibraryFilterValue) => value.value == album.artist)) {
            const libraryFilterValue: LibraryFilterValue = {
              type: 'artist',
              value: album.artist,
              selected: false
            }
            artistsFilter.values.push(libraryFilterValue)
          }
        } else {
          if (!artistsFilter.values.find((value: LibraryFilterValue) => value.value == album.artist)) {
            const libraryFilterValue: LibraryFilterValue = {
              type: 'artist',
              value: album.artist,
              selected: findedArtistsFilter.selected
            }
            artistsFilter.values.push(libraryFilterValue)
          }
        }

        album.audioFiles.forEach((af: AudioFile) => {

          const findedGenresFilter = this.genresFilter.values.find((value: LibraryFilterValue) => value.value == af.genre)

          if (!findedGenresFilter) {
            if (!genresFilter.values.find((value: LibraryFilterValue) => value.value == af.genre)) {
              const libraryFilterValue: LibraryFilterValue = {
                type: 'genre',
                value: af.genre,
                selected: false
              }
              genresFilter.values.push(libraryFilterValue)
            }
          } else {
            if (!genresFilter.values.find((value: LibraryFilterValue) => value.value == af.genre)) {
              const libraryFilterValue: LibraryFilterValue = {
                type: 'genre',
                value: af.genre,
                selected: findedGenresFilter.selected
              }
              genresFilter.values.push(libraryFilterValue)
            }
          }

          const findedRatingFilter = this.ratingsFilter.values.find((value: LibraryFilterValue) => value.value == af.rating)
          if (!findedRatingFilter) {
            if (!ratingsFilter.values.find((value: LibraryFilterValue) => value.value == af.rating)) {
              const libraryFilterValue: LibraryFilterValue = {
                type: 'rating',
                value: af.rating,
                selected: false
              }
              ratingsFilter.values.push(libraryFilterValue)
            }
          } else {
            if (!ratingsFilter.values.find((value: LibraryFilterValue) => value.value == af.rating)) {
              const libraryFilterValue: LibraryFilterValue = {
                type: 'rating',
                value: af.rating,
                selected: (findedRatingFilter !== undefined) ? findedRatingFilter.selected : false
              }
              ratingsFilter.values.push(libraryFilterValue)
            }
          }
        })
      });

      yearFilter.values.sort((a, b) => (a.value < b.value ? 1 : -1))
      this.yearFilter = yearFilter

      artistsFilter.values.sort((a, b) => (a.value < b.value ? -1 : 1))
      this.artistsFilter = artistsFilter

      genresFilter.values.sort((a, b) => (a.value < b.value ? -1 : 1))
      this.genresFilter = genresFilter

      ratingsFilter.values.sort((a, b) => (a.value < b.value ? 1 : -1))
      this.ratingsFilter = ratingsFilter
      this.updateAlbums(albums)
    },
    async updateAlbums(albumsBefore: Album[]) {

      let filteredAlbums = [] as Album[]
      let filtered = false

      if (this.filterHasSelected(this.yearFilter)) {
        albumsBefore.forEach((album: Album) => {
          if (this.yearFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == album.year)) {
            filteredAlbums.push(album)
          }
        })
        filtered = true
      }

      if (this.filterHasSelected(this.artistsFilter)) {
        albumsBefore.forEach((album: Album) => {
          if (this.artistsFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == album.artist)) {
            filteredAlbums.push(album)
          }
        })
        filtered = true
      }

      if (this.filterHasSelected(this.genresFilter)) {
        if (filtered) {
          let tempAlbums = [] as Album[]
          filteredAlbums.forEach((album: Album) => {
            let isInsertAlbum = false
            album.audioFiles.forEach((element: AudioFile) => {
              if (this.genresFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == element.genre)) {
                isInsertAlbum = true
                element.state = State.Show
              } else {
                element.state = State.Hidden
              }
            })
            if (isInsertAlbum) {
              filteredAlbums.push(album)
            }
          })
          filteredAlbums = tempAlbums
        } else {
          albumsBefore.forEach((album: Album) => {
            let isInsertAlbum = false
            album.audioFiles.forEach((element: AudioFile) => {
              if (this.genresFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == element.genre)) {
                isInsertAlbum = true
                element.state = State.Show
              } else {
                element.state = State.Hidden
              }
            })
            if (isInsertAlbum) {
              filteredAlbums.push(album)
            }
          })
        }
        filtered = true
      }

      if (this.filterHasSelected(this.ratingsFilter)) {
        if (filtered) {
          let tempAlbums = [] as Album[]
          filteredAlbums.forEach((album: Album) => {
            let isInsertAlbum = false
            album.audioFiles.forEach((element: AudioFile) => {
              if (this.ratingsFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == element.rating)) {
                isInsertAlbum = true
                element.state = State.Show
              } else {
                element.state = State.Hidden
              }
            })
            if (isInsertAlbum) {
              tempAlbums.push(album)
            }
          })
          filteredAlbums = tempAlbums
        } else {
          albumsBefore.forEach((album: Album) => {
            let isInsertAlbum = false
            album.audioFiles.forEach((element: AudioFile) => {
              if (this.ratingsFilter.values.find((value: LibraryFilterValue) => value.selected == true && value.value == element.rating)) {
                isInsertAlbum = true
                element.state = State.Show
              } else {
                element.state = State.Hidden
              }
            })
            if (isInsertAlbum) {
              filteredAlbums.push(album)
            }
          })
        }
        filtered = true
      } else {
        albumsBefore.forEach((album: Album) => {
          album.audioFiles.forEach((element: AudioFile) => {
            element.state = State.Show
          })
        })
      }

      if (!filtered) {
        filteredAlbums = albumsBefore
      }

      filteredAlbums.sort(function (a, b) {

        if (a.year < b.year) return 1;
        if (a.year > b.year) return -1;

        if (a.artist < b.artist) return -1;
        if (a.artist > b.artist) return 1;

        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;

        return 0;
      });

      console.log('count albums: ' + filteredAlbums.length)
      this.updateProcess = true
      this.albums = filteredAlbums
    }
  },
  updated() {
    if (this.updateProcess) {
      this.cursorLoading = false
      this.updateProcess = false
    }
    if (! this.mobileViewLoading) {
      const mobileView = this.$refs.mobileViewRef as HTMLElement
      if (mobileView) {
        this.mobileViewLoading = true
        mobileView.addEventListener('touchstart', this.handleTouchStart, { passive: true })
        mobileView.addEventListener('touchend', this.handleTouchEnd, { passive: true })
        window.addEventListener('keydown', this.handleKeyDown)
      }
    }
  },
  mounted() {
    const mobileView = this.$refs.mobileViewRef as HTMLElement
    if (mobileView) {
      this.mobileViewLoading = true
      mobileView.addEventListener('touchstart', this.handleTouchStart, { passive: true })
      mobileView.addEventListener('touchend', this.handleTouchEnd, { passive: true })
      window.addEventListener('keydown', this.handleKeyDown)
    }
  },
  beforeUnmount() {
    const mobileView = this.$refs.mobileViewRef as HTMLElement
    if (mobileView) {
      mobileView.removeEventListener('touchstart', this.handleTouchStart)
      mobileView.removeEventListener('touchend', this.handleTouchEnd)
      window.removeEventListener('keydown', this.handleKeyDown)
    }
  }
})
